import {
  VirtualCardsFilters,
  VirtualCardsFiltersBody,
} from 'src/components/VirtualCardsBoxAndLinks/VirtualCardsBoxAndLinks'
import { VirtualCardTypes } from 'src/enums'
import { VirtualCardStatus } from 'src/models/virtualCard.models'
import { GetVirtualCardsRequest } from 'src/requests/getVirtualCards.request'

type QueryParamValue = string | string[] | null | undefined

type MyWalletVirtualCardsQueryParams = {
  search?: QueryParamValue
  statuses?: QueryParamValue
  cardTypes?: QueryParamValue
  deactivatingIn?: QueryParamValue
  sortBy?: QueryParamValue
  sortDescending?: QueryParamValue
}

export const MY_WALLET_VIRTUAL_CARDS_DEFAULT_SORT = {
  sortBy: 'activeClosedUpdatedAt',
  sortDescending: false,
} as const

const firstQueryParamValue = (value: QueryParamValue): string | undefined => {
  if (Array.isArray(value)) {
    return value[0]
  }
  return value ?? undefined
}

const queryParamArray = <T extends string>(value: QueryParamValue): T[] => {
  if (Array.isArray(value)) {
    return value.filter(Boolean) as T[]
  }
  if (value) {
    return [value as T]
  }
  return []
}

const queryParamBoolean = (
  value: QueryParamValue,
  fallback: boolean,
): boolean => {
  const firstValue = firstQueryParamValue(value)
  return firstValue === undefined ? fallback : firstValue !== 'false'
}

export const buildMyWalletVirtualCardsInitialFilters = (
  queryParams: MyWalletVirtualCardsQueryParams,
): Partial<VirtualCardsFilters> => ({
  keyword: firstQueryParamValue(queryParams.search) || '',
  statuses: queryParamArray<VirtualCardStatus>(queryParams.statuses),
  cardTypes: queryParamArray<VirtualCardTypes>(queryParams.cardTypes),
  deactivatingIn: firstQueryParamValue(queryParams.deactivatingIn) || '',
  sortBy:
    firstQueryParamValue(queryParams.sortBy) ||
    MY_WALLET_VIRTUAL_CARDS_DEFAULT_SORT.sortBy,
  sortDescending: queryParamBoolean(
    queryParams.sortDescending,
    MY_WALLET_VIRTUAL_CARDS_DEFAULT_SORT.sortDescending,
  ),
})

export const buildMyWalletVirtualCardsRequestFilters = (
  filtersBody: VirtualCardsFiltersBody | undefined,
  userId: string | undefined,
  page?: number,
): GetVirtualCardsRequest => ({
  count: 10,
  page,
  ...filtersBody,
  recipient: userId,
})

export const buildMyWalletVirtualCardsDownloadFilters = (
  filtersBody: VirtualCardsFiltersBody,
  userId: string | undefined,
): VirtualCardsFiltersBody => ({
  ...filtersBody,
  recipient: userId,
})
